import { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import CallAPI from "../../../services/apiCalls";
import PortalLogo from "./../../../assets/images/portal-v3-icon.png";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";
import { jwtDecode } from "jwt-decode";
import {
  useIdentityServer,
  getUserRole,
  getUserSession,
  getDefaultLandingPage,
} from "../../../services/authorizationService";

const Login = () => {
  const { setUserRole, setUserToken, SetSharedObject, setUserSession } =
    useUserStore((state) => ({
      setUserRole: state.setUserRole,
      setUserToken: state.setUserToken,
      SetSharedObject: state.SetSharedObject,
      setUserSession: state.setUserSession,
    }));

  const [showPassword, setShowPassword] = useState(false);
  const [errFlag, setErrFlag] = useState(false);
  const [errFlagCred, setErrFlagCred] = useState(false);
  const [forgotFlag, setForgotFlag] = useState("");
  const [modalTxt, setModalTxt] = useState("");
  const [modalHeadTxt, setModalHeadTxt] = useState("");
  const [emailSent, setEmailSent] = useState(true);
  const [answers, setAnswers] = useState();
  const [processing, SetProcessing] = useState(false);
  const [processingModal, SetProcessingModal] = useState(false);
  const [errFlagBody, seterrFlagBody] = useState(false);
  const forgotUsernameTriggerRef = useRef(null);
  const forgotPasswordTriggerRef = useRef(null);
  const activeTriggerRef = useRef(null);
  const modalFirstFocusRef = useRef(null);
  const setAnswer = (questionId, answer) => {
    setAnswers({ ...answers, [questionId]: answer });
  };
  const navigate = useNavigate();
  const antiForgeryTokenElement = document.getElementById("AntiForgeryToken");

  useEffect(() => {
    // if using the open id connect login, see if there's currently an error generated
    // from identity server and injected into an element on the index page
    if (useIdentityServer) {
      const identityServerLoginErrorElement = document.getElementById(
        "IdentityLoginErrorPlaceholder",
      );
      if (
        identityServerLoginErrorElement &&
        identityServerLoginErrorElement.value
      ) {
        setErrFlag(identityServerLoginErrorElement.value);
      }
    }
  }, [navigate]);

  useEffect(() => {
    const modalEl = document.getElementById("ForgotCredId");
    if (!modalEl) return;
    const onShown = () => {
      setTimeout(() => modalFirstFocusRef.current?.focus(), 50);
    };
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  const Login = async (el) => {
    el.preventDefault();
    SetProcessing(true);
    SetSharedObject(null);
    let msg = "";
    setErrFlag(false);
    localStorage.setItem("SystemError", "");
    await Promise.resolve();
    let call = "/admin/Login";
    let bodyData = { username: answers.Username, password: answers.Password };

    try {
      const res = await CallAPI(call, bodyData, "post");
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let tokenJwt = jwtDecode(res.data.token);
        console.log(tokenJwt);
        setUserSession(tokenJwt);
        setUserToken(res.data.token);
        SetSharedObject("specialties", null);
        SetSharedObject("UserIdEmail", {});
        SetSharedObject("CustomerPermissionsObj", {});
        let role = getUserRole(tokenJwt);
        setUserRole(role);
        setUserSession(getUserSession(tokenJwt));
        let navPage = getDefaultLandingPage(tokenJwt, false);
        if (navPage === "/webmail") {
          if (window !== "undefined") window.open("../webmail", "_self");
        } else {
          if (role !== "USER" && navPage === "/dashboard") {
            await getUsers(res.data.token);
          }
          navigate(navPage);
        }
      } else if (res.status === "SERVERERROR") {
        msg =
          "The Username and Password you entered does not match our records.";
        setErrFlag(msg);
      } else if (res.status === "LOCKED") {
        msg =
          "Your account has been locked. Please contact your administrator for further assistance.";
        setErrFlag(msg);
      }
    } catch (err) {
      setErrFlag("An unexpected error occurred.");
    } finally {
      // always hide processing when done
      SetProcessing(false);
    }
  };

  const getUsers = async (token) => {
    SetProcessing(true);
    let call = "/users/GetUsersValues";
    const res = await CallAPI(call, false, "get", token);
    await SetSharedObject("ResponseCode", res.code);
    if (res && res.status === "SUCCESS") {
      SetSharedObject("vendorsObj", res.data.data.vendors);
      SetSharedObject("codes", res.data.data.codes);
      SetSharedObject("getOrgKinds", res.data.data.getOrgKinds);
      SetSharedObject("orgClassifications", res.data.data.orgClassifications);
      SetSharedObject("getOrgsObj", res.data.data.organizations);
      SetSharedObject("getUserEmails", res.data.data.emails);
      SetSharedObject("getServDesc", res.data.data.getServDesc);
      SetSharedObject("changePasswordFlag", false);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      setErrFlag(str);
      SetProcessing(false);
    }
  };

  const ForgotCred = (vl) => {
    seterrFlagBody(false);
    setErrFlagCred(false);
    if (vl === "username") {
      setModalTxt(
        "Your username will be sent to your valid contact email address we have on file associated with your account.",
      );
      setModalHeadTxt("Forgot your username?");
      setForgotFlag("username");
    } else {
      setModalTxt(
        "If the username you entered is valid, you will receive password reset instructions to the email address we have on file.",
      );
      setModalHeadTxt("Forgot your password?");
      setForgotFlag("password");
    }
    $("#ForgotCredId").modal("show");
  };

  const SendEmail = async (el) => {
    el.preventDefault();
    SetProcessingModal(true);
    setErrFlagCred(false);

    let call = "";
    if (forgotFlag === "username") {
      call = "/admin/ForgotUserName?email=" + answers.email;
    } else {
      call = "/admin/ForgotPassword?username=" + answers.Username;
    }
    const res = await CallAPI(call, false, "post");
    await SetSharedObject("ResponseCode", res.code);
    if (res && res.status === "SUCCESS") {
      if (forgotFlag === "username") {
        setModalTxt(
          "If an account exists for this address, Username will be sent to your contact email address. The link will expire in 24 hours.",
        );
      } else {
        setModalTxt(
          "If an account matching that username exists, an email with password reset instructions has been sent to the associated email address.",
        );
      }
      setModalHeadTxt("Email Sent");
      setEmailSent(false);
      SetProcessingModal(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "";
      for (let el of msg) {
        str += `${el}`;
      }

      setErrFlagCred(<div dangerouslySetInnerHTML={{ __html: str }} />);
      //$(".modal").modal("hide");
      SetProcessingModal(false);
    }

    //return;
    SetProcessingModal(false);
  };

  const [loadingText, setLoadingText] = useState("Signing you in...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Signing you in...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    $("#ForgotCredId").modal("hide");
    activeTriggerRef.current?.focus();
  };

  // Add Escape key handler for modals
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && $("#ForgotCredId").hasClass("show")) {
        CloseModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    // <OidcSecure>
    <div className="Login">
      <section className="ses-loginwrapper" aria-labelledby="loginHeading">
        <div className="ses-login-wrapper">
          <div className="ses-login-container">
            <form
              {...(useIdentityServer
                ? { action: `${window.location.href}`, method: "post" }
                : { onSubmit: (event) => Login(event) })}
              aria-label="Sign in to Portal"
              noValidate
            >
              {useIdentityServer ? (
                <input
                  type="hidden"
                  id="antiforgerytoken"
                  name={
                    antiForgeryTokenElement
                      ? antiForgeryTokenElement.name
                      : "antiforgerytoken"
                  }
                  value={
                    antiForgeryTokenElement
                      ? antiForgeryTokenElement.value
                      : "antiforgerytokenvalue"
                  }
                />
              ) : null}
              <div className="spacer-inline img-container">
                <img
                  src={PortalLogo}
                  className="filter-green"
                  alt=""
                  aria-hidden="true"
                />
              </div>
              <header id="loginHeading">PORTAL</header>
              <div className="form-group">
                <label htmlFor="Username">Username</label>
                <input
                  id="Username"
                  name="Username"
                  type="text"
                  className="form-control"
                  size="35"
                  required
                  aria-required="true"
                  autoComplete="username"
                  onChange={(el) => setAnswer("Username", el.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="Password">Password</label>
                <div className="input-group mb-3">
                  <input
                    id="Password"
                    name="Password"
                    type={showPassword ? "text" : "password"}
                    className="form-control password-input"
                    size="35"
                    required
                    aria-required="true"
                    autoComplete="current-password"
                    aria-describedby="passwordToggleHint"
                    onChange={(el) => setAnswer("Password", el.target.value)}
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-secondary"
                      id="basic-addon2"
                      type="button"
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      aria-pressed={showPassword}
                    >
                      {!showPassword ? (
                        <i
                          className="bi bi-eye-fill"
                          onClick={() => setShowPassword(true)}
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <i
                          className="bi bi-eye-slash-fill"
                          onClick={() => setShowPassword(false)}
                          aria-hidden="true"
                        ></i>
                      )}
                    </button>
                  </div>
                </div>
                <span id="passwordToggleHint" className="sr-only">
                  Use the button to the right to show or hide your password.
                </span>
              </div>
              <div className="form-group">
                <button
                  type="submit"
                  to=""
                  className="btn btn-success"
                  disabled={processing}
                  aria-busy={processing}
                >
                  {processing ? "Authorizing..." : "Sign In"}
                </button>
              </div>
              <div className="form-group sp-mx sp-pad6">
                <div className="forgotUserPswd">
                  <div className="spacer-inline">
                    <button
                      className="spacer-margin1 btn btn-link p-0"
                      type="button"
                      ref={forgotUsernameTriggerRef}
                      onClick={(e) => {
                        activeTriggerRef.current =
                          forgotUsernameTriggerRef.current;
                        ForgotCred("username");
                        e.preventDefault();
                      }}
                    >
                      Forgot Username
                    </button>
                  </div>
                  <div className="wrapper spacer-inline">
                    <button
                      className="btn btn-link p-0"
                      data-backdrop="static"
                      name="forgotPswdModal"
                      ref={forgotPasswordTriggerRef}
                      onClick={(e) => {
                        activeTriggerRef.current =
                          forgotPasswordTriggerRef.current;
                        ForgotCred("password");
                        e.preventDefault();
                      }}
                    >
                      Forgot Password
                    </button>
                  </div>
                </div>
              </div>
            </form>
            {/* Errors Messages */}
            {errFlag ? (
              <div className="form-group">
                <div
                  className="alert alert-danger"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  {errFlag}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section>
      {processing && (
        <div
          className="loader-container"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          aria-labelledby="loader-id"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="loader-id">
            {loadingText}
          </div>
        </div>
      )}
      <div
        className="modal fade"
        data-backdrop="static"
        id="ForgotCredId"
        tabIndex="-1"
        aria-labelledby="forgotCredModalTitle"
        aria-describedby="forgotCredModalDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <form
            onSubmit={(event) => SendEmail(event)}
            aria-label={modalHeadTxt}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title" id="forgotCredModalTitle">
                  {modalHeadTxt}
                </h3>
                <button
                  type="button"
                  className="close"
                  aria-label={`Close ${modalHeadTxt} modal`}
                  onClick={() => {
                    setEmailSent(true);
                    seterrFlagBody(false);
                    CloseModal();
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p id="forgotCredModalDesc" className="sr-only">
                  {forgotFlag === "username"
                    ? "Enter your contact email to recover your username."
                    : "Enter your username to receive a password reset link."}
                </p>
                <div className="descript2-container">{modalTxt}</div>
                {emailSent ? (
                  forgotFlag === "username" ? (
                    <div className="modal-content-form">
                      <label htmlFor="forgotEmail">Email</label>
                      <input
                        type="email"
                        id="forgotEmail"
                        className="form-control form-sm"
                        size="35"
                        required
                        aria-required="true"
                        autoComplete="email"
                        ref={modalFirstFocusRef}
                        onChange={(el) => setAnswer("email", el.target.value)}
                      />
                    </div>
                  ) : (
                    <div className="modal-content-form">
                      <label htmlFor="userName">Username</label>
                      <input
                        type="text"
                        id="userName"
                        className="form-control form-sm"
                        size="35"
                        required
                        aria-required="true"
                        autoComplete="username"
                        ref={modalFirstFocusRef}
                        onChange={(el) =>
                          setAnswer("Username", el.target.value)
                        }
                      />
                    </div>
                  )
                ) : null}
                {errFlagBody ? (
                  <div className="ml-2">
                    <div
                      className="alert alert-danger"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      {errFlagBody}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="modal-footer">
                {emailSent ? (
                  <button
                    type="submit"
                    className="btn btn-success btn-sm"
                    disabled={processingModal}
                    aria-busy={processingModal}
                  >
                    {processingModal ? "Sending..." : "Send"}
                  </button>
                ) : null}
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  disabled={processingModal}
                  onClick={() => {
                    setEmailSent(true);
                    seterrFlagBody(false);
                    CloseModal();
                  }}
                >
                  Close
                </button>
                {errFlagCred ? (
                  <div
                    className="alert alert-danger"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    {errFlagCred}
                  </div>
                ) : null}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    // </OidcSecure>
  );
};

export default Login;
